import { Component, inject, OnInit } from '@angular/core';
import { FaqsComposition } from '@shared/compositions';
import { isMobileView } from '@core/utils';
import { DialogRef } from '@ngneat/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LowerCasePipe } from '@angular/common';
import { ButtonComponent, DropdownComponent, IconComponent } from '@shared/components/ui';
import { FormErrorComponent } from '@shared/components';

@Component({
  selector: 'app-faq-category-form',
  templateUrl: './faq-category-form.component.html',
  styleUrls: ['./faq-category-form.component.scss'],
  imports: [IconComponent, FormErrorComponent, TranslateModule, DropdownComponent, ButtonComponent, ReactiveFormsModule, LowerCasePipe],
})
export class FaqCategoryFormComponent extends FaqsComposition implements OnInit {
  protected readonly isMobileView = isMobileView;
  private readonly _dialogRef: DialogRef;

  constructor() {
    super();
    if (!isMobileView()) this._dialogRef = inject(DialogRef);
  }

  ngOnInit() {
    this._initCategoryForm();
    if (!isMobileView()) {
      if (this._dialogRef && this._dialogRef.data) {
        this.currentCategory = this._dialogRef.data;
      }
    } else {
      if (this._bottomSheetService && this._bottomSheetService.currentSheetData) {
        this.currentCategory = this._bottomSheetService.currentSheetData;
      }
    }

    this.form.patchValue({
      title: this.currentCategory?.title || null,
      position: +this.currentCategory?.position || null,
    });
  }

  close(): void {
    if (!isMobileView()) {
      this._dialogRef.close();
    } else {
      this._bottomSheetService.close();
    }
  }

  save(btnRef?: ButtonComponent) {
    if (this.form.invalid) {
      this.markAllInvalidControlsAndScrollToFirst(this.form);
      return;
    }
    this.saveCategory(this.form.value, btnRef);
  }
}
